import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';

import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { ResultError } from '../../../errors/result/result-error';
import { GROUP_PICK_COMBO_PICK_VALIDATORS } from '../../betslip-validation-injection-tokens';

type InjectionTokenType<T> = T extends InjectionToken<infer T1> ? T1 : never;
type GroupPickComboValidator = InjectionTokenType<typeof GROUP_PICK_COMBO_PICK_VALIDATORS>;

@Injectable()
export class GroupPicksComboPreventionValidator {
    constructor(@Optional() @Inject(GROUP_PICK_COMBO_PICK_VALIDATORS) private groupPickComboValidators: GroupPickComboValidator[]) {}

    validate(picks: BetslipPick[]): ResultError[] {
        return picks.flatMap((pick) => this.groupPickComboValidators?.flatMap((validator) => validator.validate(pick)) ?? []);
    }
}
